import { ApiProperty } from '@nestjs/swagger';
export class LogIdRequest {
    @ApiProperty()
    productionLogid: number;
}